/**
 * 定义实时解盘类
 */
class REALTIMESOLUTION {
    /**
     * 处理实时解盘标记类构造函数
     * @param {Object} markPointOption markPoint选项
     * @param {Array<Object>} markPoints 标记点序列
     * @param {Array<Array<Number>>} klineDatas K线数据
     */
    constructor(markPointOption, markPoints = [], klineDatas = []) {
        this.markPointOption = markPointOption;
        this.markPoints = markPoints;
        this.klineDatas = klineDatas;
        // 记录离现在最近的时间点以及markPoint的索引
        this.position = {
            time: -1,
            markPoint: -1
        };
    }

    /**
     * 生成实时解盘MarkPoint选项
     * @returns {Array<Object>} 返回生成的实时解盘标记点选项
     */
    generateMarkPointOption() {
        let results = this.markPoints.map((markPoint, i) => {
            // 处理坐标的方法需要当前MarkPoint的索引
            markPoint.index = i;

            let option = JSON.parse(JSON.stringify(this.markPointOption));
            option.coord = this.processCoord(markPoint);
            option.label.formatter = this.processConent(markPoint.content);

            return option;
        });

        // 默认点击离现在最近的一个markpoint
        if (this.position.markPoint > -1) {
            results[this.position.markPoint].label.show = true;
        }

        return results;
    }

    /**
     * 处理实时解盘的坐标
     * @param {Object} markPoint 标记的点
     * @returns {Array<Number>} 返回处理后的结果
     */
    processCoord(markPoint) {
        // 记录离现在最近的时间点
        if (markPoint.timeIndex > this.position.time) {
            this.position.time = markPoint.timeIndex;
            this.position.markPoint = markPoint.index;
        }
        let price = '';
        // 标记在最高价还是最低价上
        if (markPoint.isHighest) {
            price = this.klineDatas[markPoint.timeIndex][3];
        } else {
            price = this.klineDatas[markPoint.timeIndex][2];
        }

        return [markPoint.time, price];
    }

    /**
     * 处理实时解盘的文字
     * @param {String} content 要处理的MarkPoint里的文字
     * @returns {String} 返回处理后的结果
     */
    processConent(content) {
        // 在指定长度字符数后面增加\n，如果\n是最后一个字符，则删除
        let charLength = 0;
        let oneRowIndex = [];
        for (let i = 0; i < content.length; i++) {
            const code = content.codePointAt(i);
            // 对于对于那些需要4个字节储存的字符（Unicode 码点大于0xFFFF的字符），JavaScript 会认为它们是两个字符，但实际上仍然是一个汉字
            // 所以计算长度时需要跳过一个字符
            if (code > 65535) {
                continue;
            }
            if (code > 128) {
                charLength += 2;
            } else {
                charLength += 1;
            }
            if (charLength >= 20) {
                charLength = 0;
                // 因为i是索引，从0开始的，所以需要+1
                oneRowIndex.push(i + 1);
            }
        }
        oneRowIndex.forEach((index, i) => {
            content = content.replace(new RegExp(`((?:.|\n){${index + i}})`), '$1\n');
        });
        content = content.replace(/\n$/, '');
        return content;
    }
}

export default REALTIMESOLUTION;



// WEBPACK FOOTER //
// ./src/controller/series/markPoint/REALTIMESOLUTION.js